export const HtmlRaw = ({text=''}:{text:string}) =>{
    return <b className='fs-3' dangerouslySetInnerHTML={{__html:text.replace(/\n/g,'<br />')}} />
}